import { render, staticRenderFns } from "./collapser.vue?vue&type=template&id=20f0451a&scoped=true&"
import script from "./collapser.vue?vue&type=script&lang=js&"
export * from "./collapser.vue?vue&type=script&lang=js&"
import style0 from "./collapser.vue?vue&type=style&index=0&id=20f0451a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20f0451a",
  null
  
)

export default component.exports